import styled from 'styled-components';
import { SvgIcon } from '../SvgIcon/SvgIcon';

export const StyledAppLogo = styled(SvgIcon)`
  width: calc(100% - 100px);
  margin: 1rem auto;
`;